import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Theme, useTheme } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(({ palette }: Theme) => ({
  root: {
    position: 'fixed',
    top: 'calc(50% - 10em)',
    bottom: 'calc(50% - 10em)',
    right: 'calc(50% - 10em)',
    left: 'calc(50% - 10em)',
    zIndex: 1,
    '& > *': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
  },
  ring: {
    margin: 'auto'
  },
  '@keyframes ring': {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(360deg)'
    }
  },
  ringing: {
    borderColor: `${palette.primary.main} transparent transparent transparent`,
    width: 70,
    height: 70,
    margin: 42,
    borderWidth: 10,
    background: 'rgba(0, 0, 0, 0.11)',
    border: '8px solid #fff',
    borderRadius: '50%',
    animation: '$ring 1.2s linear infinite',
  },
  image: {
    width: 64,
    height: 64,
    zIndex: 2
  }
}));

const Loading = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <img
        alt="Rguroo Logo Loader"
        className={classes.image}
        src="/images/logos/logo.svg"
      />
      <div className={classes.ring}>
        <div className={classes.ringing} />
      </div>
    </div>
  );
};

interface LoadingRingProps {
  size?: number,
  ringSize?: number,
  color?: string,
  className?: string
}

export const LoadingRing = (props: LoadingRingProps) => {
  const theme = useTheme();
  const {size = 20, ringSize = 3, color = theme.palette.primary, className} = props;
  const classes = useStyles();

  return <div className={clsx(classes.ring, className)}>
    <div 
      className={classes.ringing} 
      style={{borderWidth: ringSize, height: size, width: size, margin: 0, background: 'none', borderColor: `${color} transparent transparent transparent`}} 
    />
  </div>
}

export default Loading;
